import { ETextParamType_CancelToCopyVideoFrameToSystem, ETextParamType_CopyVideoFrameToSystem, worldViewerWindow } from './const';
import { debugLog } from './debugLog';
import { getSceneJsonPath, getVideoAudioContext, getVideoEndedToggle, getVideoGainNode, getVideoHlsConfig, getVideoSource, setSceneJson, setVideoAudioContext, setVideoCanPlayToggle, setVideoEndedToggle, setVideoGainNode, setVideoHlsConfig, setVideoInfo, setVideoSource, setVideoSourceUrl } from './logics/dataOps';
import { getVideo, setVideo } from './logics/domOps';
import { hel_isiPhone, hel_isMac } from './logics/platform';
const hel_video_node_gain = ()=>{
    if (!hel_isiPhone() && !hel_isMac()) {
        // iOS/Mac以外ではVideo.volumeが使えるのでgainNodeは生成しない
        return;
    }
    if (getVideoAudioContext() === undefined) {
        setVideoAudioContext(new (worldViewerWindow.AudioContext || worldViewerWindow.webkitAudioContext)());
    }
    if (getVideoSource() === undefined) {
        setVideoSource(getVideoAudioContext().createMediaElementSource(getVideo()));
    }
    if (getVideoGainNode() === undefined) {
        setVideoGainNode(getVideoAudioContext().createGain());
        getVideoSource().connect(getVideoGainNode());
        getVideoGainNode().connect(getVideoAudioContext().destination);
    }
};
/**
 * @remarks
 * C++から呼出し
 * @param uint8Array
 * @param x
 * @param y
 * @param width
 * @param height
 */ worldViewerWindow.g_on_video_frame_capture = (uint8Array, x, y, width, height)=>{
    // default implement
    debugLog('worldViewerWindow.g_on_video_frame_capture:', uint8Array, x, y, width, height);
};
// Video
/**
 * @remarks
 * C++から呼出し
 * @param loop
 */ worldViewerWindow.hel_video_Prepare = (loop)=>{
    const video = getVideo();
    if (video !== undefined) {
        return;
    }
    // document.pictureInPictureEnabled = false;
    //	worldViewerWindow.g_Video = document.createElement('video');
    const updatedVideo = document.getElementById('video0');
    setVideo(updatedVideo);
    //	worldViewerWindow.g_Video.autoplay = false;
    updatedVideo.loop = loop;
    //	worldViewerWindow.g_Video.type = 'video/mp4';
    //	worldViewerWindow.g_Video.autoPictureInPicture = false;
    //	worldViewerWindow.g_Video.disablePictureInPicture = true;
    //	worldViewerWindow.g_Video.controlslist = "nodownload";
    //	worldViewerWindow.g_Video.playsinline = true;
    setVideoEndedToggle(false);
    updatedVideo.onseeking = ()=>setVideoCanPlayToggle(false)
    ;
    updatedVideo.onseeked = ()=>setVideoCanPlayToggle(true)
    ;
    updatedVideo.oncanplay = ()=>setVideoCanPlayToggle(false)
    ;
    updatedVideo.oncanplaythrough = ()=>{
        setVideoCanPlayToggle(true);
    };
    updatedVideo.onerror = function() {
        this.onerror = null;
    };
    updatedVideo.onended = (event)=>{
        debugLog(`g_Video onEnded ${JSON.stringify(event)}`);
        setVideoEndedToggle(true);
    };
    updatedVideo.addEventListener('loadedmetadata', ()=>{
        if (typeof worldViewerWindow.hel_video_on_loadedmetadata === 'function') {
            worldViewerWindow.hel_video_on_loadedmetadata();
        }
    });
};
/**
 * @remarks
 * C++から呼出し
 * @param videoSrc
 * @param videoStreaming
 */ worldViewerWindow.hel_video_play = async (videoSrc, videoStreaming)=>{
    setVideoSourceUrl(videoSrc);
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    if (videoStreaming != 0) {
        if (typeof IVSPlayer !== 'undefined' && IVSPlayer.isPlayerSupported) {
            hel_video_node_gain();
            const player = IVSPlayer.create();
            player.attachHTMLVideoElement(video);
            player.load(videoSrc);
            player.play();
        } else if (typeof Hls !== 'undefined' && Hls.isSupported()) {
            hel_video_node_gain();
            // Create Hls
            let hls;
            const hlsConfig = getVideoHlsConfig();
            if (hlsConfig !== undefined) {
                hls = new Hls(hlsConfig);
            } else {
                hls = new Hls();
            }
            //
            hls.loadSource(videoSrc);
            hls.attachMedia(video);
            await video.play();
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            hel_video_node_gain();
            video.src = videoSrc;
            await video.play();
        } else {
            debugLog('video streaming not supported');
        }
    } else {
        hel_video_node_gain();
        video.src = videoSrc;
        await video.play();
    }
};
/**
 * @remarks
 * C++から呼出し
 */ worldViewerWindow.hel_video_stop = ()=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    video.pause();
// setVideo(null);
};
/**
 * @remarks
 * C++から呼出し
 * @param pause_enable
 */ worldViewerWindow.hel_video_playpause_toggle = async (pause_enable)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    if (pause_enable) {
        video.pause();
    } else {
        await video.play();
    }
};
/**
 * @remarks
 * C++から呼出し
 */ worldViewerWindow.hel_video_is_paused = ()=>{
    const video = getVideo();
    if (video === undefined) {
        return true;
    }
    return video.paused;
};
/**
 * @remarks
 * C++から呼出し
 * @param seconds
 */ worldViewerWindow.hel_video_add_forward = (seconds)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    video.currentTime += seconds;
};
/**
 * @remarks
 * C++から呼出し
 */ worldViewerWindow.hel_video_isplay = ()=>{
    const video = getVideo();
    if (video === undefined) {
        return false;
    }
    return !(video.loop && getVideoEndedToggle());
};
/**
 * @remarks
 * C++から呼出し
 * @param seconds
 */ worldViewerWindow.hel_video_add_rewind = (seconds)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    video.currentTime -= seconds;
};
/**
 * @remarks
 * C++から呼出し
 */ worldViewerWindow.hel_video_get_duration = ()=>{
    const video = getVideo();
    if (video === undefined) {
        return 0;
    }
    return video.duration;
};
/**
 * @remarks
 * C++から呼出し
 * @param sliderRate
 */ worldViewerWindow.hel_video_set_currenttime = (sliderRate)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    if (video.duration > 0) {
        video.currentTime = sliderRate * video.duration;
    }
};
/**
 * @remarks
 * C++から呼出し
 */ worldViewerWindow.hel_video_get_currenttime = ()=>{
    const video = getVideo();
    if (video === undefined) {
        return 0;
    }
    return video.currentTime;
};
/**
 * @remarks
 * heliodor_front.js等から呼ばれるケースが多い
 */ worldViewerWindow.hel_video_SetHlsConfig = (config)=>setVideoHlsConfig(config)
;
/**
 * 未使用
 * @param seconds
 */ worldViewerWindow.hel_video_seek = (seconds)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    video.currentTime = seconds;
};
/**
 * @remarks
 * heliodor_xrw_video等から呼び出しあり
 * @param mute
 */ worldViewerWindow.hel_video_SetMute = (mute)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    video.muted = mute;
};
/**
 * 未使用
 */ worldViewerWindow.hel_video_get_slider_rate = ()=>{
    const video = getVideo();
    if (video === undefined) {
        return 0.0;
    }
    let sliderRate = 0.0;
    if (video.duration > 0.0) {
        sliderRate = video.currentTime / video.duration;
    }
    return sliderRate;
};
/**
 * 未使用
 * @param x
 * @param y
 * @param width
 * @param height
 */ worldViewerWindow.hel_video_copy_video_frame_to_system = (x, y, width, height)=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    const w = width != null ? width : video.videoWidth;
    const h = height != null ? height : video.videoHeight;
    const findVideoJson = (json)=>{
        for (const item of json.items){
            if (item.clickablenodes != null) {
                for (const node of item.clickablenodes){
                    if (node.eventmap !== null && node.eventmap !== undefined) {
                        return node;
                    }
                }
            }
        }
        return undefined;
    };
    const sceneJsonPath = getSceneJsonPath();
    if (sceneJsonPath === undefined) {
        console.error('sceneJsonPath not found');
        return;
    }
    fetch(sceneJsonPath).then((response)=>{
        response.json().then((json)=>{
            setSceneJson(json);
            const node = findVideoJson(json);
            if (node != null) {
                setVideoInfo(node);
                worldViewerWindow.hel_setText(ETextParamType_CopyVideoFrameToSystem, `${x},${y},${w},${h}`);
            } else {
                console.error('The video info not found in the scene json file.');
            }
        });
    });
};
/**
 * 未使用
 */ worldViewerWindow.hel_video_cancel_to_copy_video_frame_to_system = ()=>{
    const video = getVideo();
    if (video === undefined) {
        return;
    }
    worldViewerWindow.hel_setText(ETextParamType_CancelToCopyVideoFrameToSystem, '');
};
